module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-brands-400.eot?102e0cb0fde795fc49a8dfedbb82d8ad";